import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: James Coyle
 * id BD09D9F0-FF38-4D14-8798-2CB5091CABE1
 * name calendar-blank-multiple
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar-blank-multiple.svg
 * tags
 * - Date / Time 
 */
export const CalendarBlankMultipleIcon = createSvgIcon(<><path d="M21 17V8H7V17H21M21 3C22.1 3 23 3.9 23 5V17C23 18.1 22.1 19 21 19H7C5.89 19 5 18.1 5 17V5C5 3.9 5.9 3 7 3H8V1H10V3H18V1H20V3H21M3 21H17V23H3C1.89 23 1 22.1 1 21V9H3V21Z" /></>, 'CalendarBlankMultipleIcon');
export default CalendarBlankMultipleIcon